const QueryParams = require('../util/queryParamProcessor')
function constructSheetUrl(sheetName) {
  const noParamsUrl = window.location.href.substring(0, window.location.href.indexOf(window.location.search))
  const queryParams = QueryParams(window.location.search.substring(1))
  const sheetUrl = noParamsUrl + '?documentId=' + queryParams.documentId + '&sheetName=' + encodeURIComponent(sheetName)
  return sheetUrl
}

function getQuadrantFromURL() {
  const queryParams = QueryParams(window.location.search.substring(1))
  const quadrantQueryString = queryParams.quadrant

  if (quadrantQueryString) {
    return quadrantQueryString.toLowerCase()
  }

  return 'all'
}

module.exports = {
  constructSheetUrl,
  getQuadrantFromURL,
}
